/**
 * Clears all data from localStorage
 * Used during logout to ensure no authentication or session data persists
 * Note: This clears ALL localStorage, not just auth-related items
 */
export const cleanLocalStorage = () => {
  localStorage.clear();
};

/**
 * Handles user logout by clearing all localStorage data and redirecting
 * Use this in axios interceptors where you need to redirect via window.location
 * For React Router navigation, use cleanLocalStorage() directly with navigate()
 * 
 * @param {string} redirectPath - Path to redirect to after logout (default: "/Login")
 */
export const handleLogout = (redirectPath = "/Login") => {
  cleanLocalStorage();
  window.location.href = redirectPath;
};
